import { useEffect, useState } from 'react';
import { fetchRenewalsUpcoming } from '../../utils/insuranceApi';
import { useHouseholdDetail } from '../../context/HouseholdDetailContext';

export default function RenewalCalendar() {
  const [renewals, setRenewals] = useState([]);
  const [loading, setLoading] = useState(true);
  const { openHousehold } = useHouseholdDetail();

  useEffect(() => {
    fetchRenewalsUpcoming(120).then(data => {
      setRenewals(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="bg-white rounded-[4px] p-12 text-center text-[12px] text-[#888]">Loading...</div>;

  if (renewals.length === 0) {
    return (
      <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-12 text-center">
        <div className="text-[40px] mb-3 opacity-30">📅</div>
        <p className="text-[14px] text-navy font-bold mb-1">No upcoming renewals</p>
        <p className="text-[12px] text-[#888]">
          Renewal tasks are auto-created 30 days before each policy expires.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] overflow-hidden">
      <table className="w-full text-[12px]">
        <thead className="bg-gray-50">
          <tr className="text-left">
            <th className="px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-[#888]">Renewal Date</th>
            <th className="px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-[#888]">Days Out</th>
            <th className="px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-[#888]">Household</th>
            <th className="px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-[#888]">Policy</th>
            <th className="px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-[#888]">Status</th>
          </tr>
        </thead>
        <tbody>
          {renewals.map(r => {
            const days = Math.round((new Date(r.renewal_date) - new Date()) / (1000 * 60 * 60 * 24));
            const urgent = days <= 30;
            return (
              <tr key={r.id} className={`border-t border-gray-100 ${urgent ? 'bg-rose/5' : ''}`}>
                <td className="px-4 py-2 font-bold">{r.renewal_date}</td>
                <td className={`px-4 py-2 ${urgent ? 'text-rose font-bold' : ''}`}>{days} days</td>
                <td className="px-4 py-2">
                  <button
                    onClick={() => openHousehold(r.household_id)}
                    className="text-navy hover:text-bullogic-blue hover:underline transition-colors text-left"
                    title="Open household card"
                  >
                    {r.household_name || r.household_id}
                  </button>
                </td>
                <td className="px-4 py-2">{r.product_type} · {r.carrier_name || ''}</td>
                <td className="px-4 py-2">{r.status}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
